import { createFileRoute } from '@tanstack/react-router'
import { QuotedVsActualPage } from '@/features/quoted-vs-actual/quoted-vs-actual-page'
import { validateQuotedVsActualSearch } from '@/features/quoted-vs-actual/search-state'

export const Route = createFileRoute('/_authenticated/quoted-vs-actual')({
  staticData: { title: 'Quoted vs Actual' },
  validateSearch: validateQuotedVsActualSearch,
  component: QuotedVsActualRoute,
})

function QuotedVsActualRoute() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <QuotedVsActualPage
      searchParams={search}
      onSearchParamsChange={(next, { replace }) => {
        void navigate({ search: next, replace, resetScroll: false })
      }}
    />
  )
}
